export type QuoteFilter = 'ALL' | 'USD' | 'USDT' | 'BTC' | 'ETH' | 'EUR';

export const QUOTE_FILTERS: QuoteFilter[] = ['ALL', 'USD', 'USDT', 'BTC', 'ETH', 'EUR'];

const FILTER_QUOTE_VARIANTS: Record<string, string[]> = {
  USD: ['USD', 'ZUSD'],
  USDT: ['USDT'],
  BTC: ['BTC', 'XBT'],
  ETH: ['ETH'],
  EUR: ['EUR', 'ZEUR'],
};

export function symbolMatchesQuote(
  ticker: { symbol: string; wsSymbol?: string },
  filter: QuoteFilter,
): boolean {
  if (filter === 'ALL') return true;
  const variants = FILTER_QUOTE_VARIANTS[filter] ?? [filter];

  // Check wsSymbol quote (most reliable)
  if (ticker.wsSymbol) {
    const parts = ticker.wsSymbol.split('/');
    const wsQuote = (parts[1] ?? '').toUpperCase();
    if (variants.includes(wsQuote)) return true;
  }

  // Check raw symbol code as fallback
  const code = ticker.symbol.toUpperCase();
  for (const v of variants) {
    if (code.endsWith(v) || code.endsWith(`Z${v}`)) return true;
  }

  return false;
}
